import { Checkbox } from './ui/checkbox';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { getGbpOfferDetails, getGbpOffers } from '../config/gbpOffers.ts';

export const createGbpOffersValue = (category) => ({
  category,
  offers: getGbpOffers(category),
  selectedOffers: []
});

const GbpOffersPicker = ({ category, value, onChange, disabled = false }) => {
  const isMatchingCategory = value?.category === category;
  const offers = isMatchingCategory
    ? value?.offers || []
    : getGbpOffers(category);
  const selectedOffers = isMatchingCategory ? value?.selectedOffers || [] : [];

  if (!category) return null;

  if (offers.length === 0) {
    return (
      <p className="rounded-xl bg-muted/50 p-3 text-sm text-muted-foreground">
        There are no suggested Google Business Profile offers for this category.
      </p>
    );
  }

  const update = (patch) =>
    onChange({
      category,
      offers,
      selectedOffers,
      ...patch
    });

  return (
    <div className="space-y-3">
      <div>
        <p className="font-medium">Google Business Profile offers</p>
        <p className="text-sm text-muted-foreground">
          Select the offers you want to post. You can edit their wording.
        </p>
      </div>
      {offers.map((offer, index) => {
        const isSelected = selectedOffers.includes(index);
        const usedBy = getGbpOfferDetails(category)[index]?.usedBy;

        return (
          <div
            key={`${category}-${index}`}
            className={`flex items-start gap-3 rounded-xl border p-3 ${
              isSelected ? 'border-primary bg-primary/5' : 'border-border'
            }`}>
            <Checkbox
              checked={isSelected}
              disabled={disabled}
              aria-label={`Select offer ${index + 1}`}
              className="mt-3.5 shrink-0"
              onCheckedChange={(checked) =>
                update({
                  selectedOffers: checked
                    ? [...selectedOffers, index]
                    : selectedOffers.filter((selected) => selected !== index)
                })
              }
            />
            <div className="min-w-0 flex-1 space-y-1.5">
              {offer.includes('\n') ? (
                <Textarea
                  value={offer}
                  aria-label={`Offer ${index + 1}`}
                  disabled={disabled}
                  onChange={(event) =>
                    update({
                      offers: offers.map((currentOffer, offerIndex) =>
                        offerIndex === index ? event.target.value : currentOffer
                      )
                    })
                  }
                  className="min-h-24 w-full resize-y text-sm leading-relaxed"
                />
              ) : (
                <Input
                  value={offer}
                  aria-label={`Offer ${index + 1}`}
                  disabled={disabled}
                  onChange={(event) =>
                    update({
                      offers: offers.map((currentOffer, offerIndex) =>
                        offerIndex === index ? event.target.value : currentOffer
                      )
                    })
                  }
                  className="h-11 w-full min-w-0 text-sm"
                />
              )}
              {usedBy && (
                <p className="text-xs italic leading-snug text-muted-foreground/80">
                  {usedBy}
                </p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default GbpOffersPicker;
